export const changeNullForStringValue = (array, prevent = []) => {
  const recursiveObj = (obj, attKey = "") => {
    if (Array.isArray(obj)) {
      return obj.map(item => recursiveObj(item))
    } else if (obj !== null && typeof obj === 'object') {
      // console.log(`\n${attKey ? `${attKey}` : `-------\nROOT:`} --->`, obj)
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          return [key, recursiveObj(value, key)]
        })
      )
    } else if (obj === null || obj === undefined) {
      // console.log(`Null encontrado em:`, attKey)
      if (prevent.includes(attKey)) return obj
      return ""
    }
    return obj
  };
  
  return recursiveObj(array)
}